<template>
  <div v-if="showQuickJump" class="pagination-quick-jump">
    <span class="quick-jump-label">Aller à la page:</span>
    <Input
      :model-value="quickJumpPage"
      type="number"
      :min="1"
      :max="totalPages"
      @update:model-value="$emit('update:quick-jump-page', $event)"
      @keyup.enter="$emit('quick-jump')"
      class="quick-jump-input"
      :disabled="loading"
    />
    <Button
      variant="secondary"
      size="sm"
      @click="$emit('quick-jump')"
      :disabled="loading || !isValidQuickJumpPage"
      class="quick-jump-btn"
    >
      Aller
    </Button>
  </div>
</template>

<script setup>
import Button from '../Button.vue'
import Input from '../Input.vue'

defineProps({
  showQuickJump: Boolean,
  quickJumpPage: String,
  totalPages: Number,
  isValidQuickJumpPage: Boolean,
  loading: Boolean
})

defineEmits(['update:quick-jump-page', 'quick-jump'])
</script>

<style scoped>
.pagination-quick-jump {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
  justify-content: center;
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--color-border-light);
  width: 100%;
}

.quick-jump-label {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  white-space: nowrap;
}

.quick-jump-input {
  width: 80px;
  margin-bottom: 0;
}

.quick-jump-input :deep(.form-group) {
  margin-bottom: 0;
}

.quick-jump-input :deep(input) {
  text-align: center;
}

.quick-jump-btn {
  white-space: nowrap;
}

@media (max-width: 768px) {
  .pagination-quick-jump {
    flex-direction: column;
    align-items: stretch;
  }

  .quick-jump-label {
    text-align: center;
  }

  .quick-jump-input {
    width: 100%;
  }

  .quick-jump-btn {
    width: 100%;
  }
}
</style>
